import LandingNav from "@/components/landing/LandingNav";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import Features from "@/components/landing/Features";
import LiveEventsPreview from "@/components/landing/LiveEventsPreview";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <LandingNav />
      <Hero />
      <HowItWorks />
      <Features />
      <LiveEventsPreview />
      <ContactSection />
      <Footer />
    </div>
  );
}
